"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
const redux_1 = require("redux");
const redux_devtools_extension_1 = require("redux-devtools-extension");
const reducers_1 = require("./ducks/reducers");
exports.store = redux_1.createStore(reducers_1.rootReducer, redux_devtools_extension_1.composeWithDevTools());
//# sourceMappingURL=Store.js.map